import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormControlDirective } from 'angular-v2-directives';
import { format } from 'date-fns';
import { BsDatepickerModule, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';

import { ErrorMessageComponent } from '../error-messages/error-message.component';
import { FormComponent } from '../form/form.component';

@Component({
  selector: 'ui-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None, // @TODO: change encappsulation to default
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    TranslateModule,
    BsDatepickerModule,
    ErrorMessageComponent,
    FormControlDirective,
    FormComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true,
    },
  ],
})
export class DatepickerComponent implements OnInit, OnDestroy {
  @Input() bsConfig: Partial<BsDaterangepickerConfig> = {
    adaptivePosition: true,
    containerClass: 'theme-sh',
    rangeInputFormat: 'DD-MM-YYYY',
    dateInputFormat: 'DD-MM-YYYY',
    showWeekNumbers: false,
    customTodayClass: 'today-picker-cell',
  };
  @Input() label?: string;
  @Input() formControlName?: string | any;
  @Input() formGroup?: FormGroup | any;
  @Input() required = false;
  @ViewChild('input') input?: ElementRef;
  value: any;
  isDisabled = false;
  private subscription = new Subscription();

  get dateFrom(): string {
    return format(this.value[0], 'EEE, MMM d');
  }

  get dateTo(): string {
    return format(this.value[1], 'EEE, MMM d');
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(disabled: boolean): void {
    this.isDisabled = disabled;
  }

  ngOnInit() {
    this.subscription.add(
      this.formGroup.get(this.formControlName)?.valueChanges.subscribe((data: string[]) => {
        this.value = data;
        this.onTouched();
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
